import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Factory',
    column_type: 'id',
    label_key_path: 'factory.id',
  },
  created_at: {
    model_name: 'Factory',
    column_type: 'datetime',
    label_key_path: 'factory.createdAt',
  },
  updated_at: {
    model_name: 'Factory',
    column_type: 'datetime',
    label_key_path: 'factory.updatedAt',
  },
  name: {
    model_name: 'Factory',
    column_type: 'string',
    label_key_path: 'factory.name',
  },
  company: {
    model_name: 'Factory',
    column_type: 'belongs_to',
    label_key_path: 'factory.company',
    extra: {
      association_name: 'company',
      model_name: 'Company',
      foreign_key: 'company_id',
      display_column: 'name',
    },
  },
  company_id: {
    model_name: 'Factory',
    column_type: 'belongs_to',
    label_key_path: 'factory.company',
    extra: {
      association_name: 'company',
      model_name: 'Company',
      foreign_key: 'company_id',
      display_column: 'name',
    },
  },
  abilities: {
    model_name: 'Factory',
    column_type: 'string',
    label_key_path: 'factory.abilities',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
